import { useState } from "react";
import {
  FaArrowRight,
  FaPlus,
  FaMinus,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";

import PrinciperModal from "../components/PrinciperModal";
import ProcessmodellModal from "../components/ProcessmodellModal2";
import SamverkanModal from "../components/SamverkanModal";

const kontakter = [
  ["Sofia Groth", "070-203 41 08", "sofia.groth@hudiksvall.se"],
];

const principles = [
  {
    number: "01",
    title: "Vi börjar med människan – inte hindren",
    text: `I Räkna med mig börjar vi med att lära känna människan bakom de kontakter och erfarenheter hon har med sig. Många unga har redan fått berätta mycket om sina svårigheter, så hos oss får intressen, styrkor och drömmar ta större plats. Vi utgår från det som fungerar och från vad den unga själv tycker är viktigt. Tillsammans formar vi ett stöd som passar personens mål, önskemål och utvecklingstakt.`,
  },
  {
    number: "02",
    title: "Relation före prestation",
    text: `En trygg relation är grunden för att den unga ska våga prova nya saker och arbeta mot sina mål. Därför tar vi tid att lyssna, visa intresse och göra det vi har kommit överens om. Vi bygger också relationer mellan de verksamheter som ger stöd, så att de kan samarbeta och skapa en tryggare, mer sammanhållen väg framåt för den unga.`,
  },
  {
    number: "03",
    title: "Delaktighet i varje steg",
    text: `Delaktighet betyder mer än att få information eller säga ja eller nej till en färdig plan. Den unga känner sitt eget liv bäst och är med och utforskar vad som är viktigt, formulerar mål och bestämmer hur stödet ska se ut. Vi bidrar med vår kunskap och anpassar hur vi arbetar, så att den unga kan påverka utifrån sina förutsättningar. De unga ska också vara med och utveckla Räkna med mig: deras idéer och erfarenheter ska påverka vilka aktiviteter vi erbjuder och hur vi arbetar och samverkar.`,
  },
  {
    number: "04",
    title: "Vi bygger vidare på det som fungerar",
    text: `Vi söker efter sådant som redan fungerar i den ungas liv – ett intresse, en relation, en erfarenhet eller en förmåga – och använder det som grund för nästa steg. Vi behöver förstå vilka svårigheter som finns för att kunna anpassa stödet, men det är den ungas styrkor och möjligheter som vägleder arbetet. Samma synsätt gäller i samarbetet mellan verksamheter: vi tar vara på varandras kunskap och fungerande arbetssätt. Vi uppmärksammar också små framsteg, eftersom de kan öppna vägen för fortsatt utveckling.`,
  },
  {
    number: "05",
    title: "Vi bygger samverkan genom förståelse och tillit",
    text: `För att ge den unga ett sammanhållet stöd behöver vi förstå varandras uppdrag, ansvar och förutsättningar. Vi utgår från att alla vill göra ett bra arbete och försöker förstå varandras perspektiv innan vi drar slutsatser om det som är svårt. När vi tycker olika pratar vi öppet om det och söker lösningar tillsammans. Tillit växer när vi håller det vi har kommit överens om, är tydliga med vad vi kan göra och respekterar varandras kunskap.`,
  },
  {
    number: "06",
    title: "Vi har ett helhetsperspektiv",
    text: `Hälsa, relationer, ekonomi och vardag påverkar möjligheten att närma sig studier eller arbete. Därför planerar vi stödet utifrån den ungas hela livssituation och tar hänsyn till det som redan pågår. Ibland kan flera saker utvecklas samtidigt; ibland behöver vi fokusera på färre saker eller avvakta. När flera verksamheter är involverade arbetar vi för att deras insatser ska hänga ihop och underlätta för den unga.`,
  },
  {
    number: "07",
    title: "Vi stärker hopp och framtidstro",
    text: `Efter många motgångar kan det vara svårt att tro att framtiden kan se annorlunda ut. Då behöver vi fortsätta tro på den ungas möjligheter, också när hen själv har svårt att göra det. Vi synliggör styrkor och framsteg och delar upp större mål i steg som går att ta. Förändring kan ta tid, men genom att märka sin egen utveckling kan den unga gradvis få tillbaka tilliten till sin förmåga.`,
  },
  {
    number: "08",
    title: "Vi lär och utvecklas tillsammans",
    text: `Räkna med mig är ett arbetssätt som fortsätter att utvecklas när vi får nya erfarenheter och behoven förändras. Vi tar vara på de ungas kunskap om sina liv, medarbetarnas erfarenheter och det vi lär oss genom forskning. Tillsammans följer vi upp arbetet och försöker förstå både det som fungerar och det som behöver förändras. Genom att dela erfarenheter och reflektera i vardagen kan vi fortsätta förbättra stödet.`,
  },
  {
    number: "09",
    title: "Vi vågar pröva, följa upp och förbättra",
    text: `När vi ser ett behov väntar vi inte på att ha en färdig lösning. Vi prövar idéer i liten skala, följer upp hur de fungerar och ändrar det som behöver bli bättre. De unga, medarbetarna och våra samverkansparter är med och bidrar med sina erfarenheter. På så sätt kan vi bygga vidare på det som fungerar och utveckla stödet när behoven förändras.`,
  },
  {
    number: "10",
    title: "Vi tar ansvar för vår arbetsmiljö och vårt engagemang",
    text: `Hur vi mår och bemöter andra påverkar det stöd vi kan ge de unga. Därför behöver vi ta hand om både oss själva och varandra, med utrymme för stöd, återhämtning och gemensam reflektion. Om energi eller arbetsglädje minskar behöver vi kunna prata om det och förändra det som behövs. Ansvaret är både personligt och gemensamt, så att vi kan behålla vårt engagemang över tid.`,
  },
];

const teamet = [
  {
    name: "Sofia Groth",
    role: "Insatsledare, Hudiksvalls kommun",
    image: "/Sofia.jpg",
    email: "sofia.groth@hudiksvall.se",
    phone: "",
    text: `Jag är socionom i grunden men har främst arbetat med projekt och utvecklingsfrågor sedan 2020. Det jag tycker mest om med projektarbete är möjligheten att lyssna på dem stödet är till för, prova nya idéer och utveckla insatser utifrån det vi lär oss.

Jag brinner särskilt för frågor som rör unga som riskerar att hamna i utanförskap. Alla unga har olika förutsättningar och behöver olika vägar framåt. Som vuxna har vi ett ansvar att se deras möjligheter, ta deras erfarenheter på allvar och skapa förutsättningar för var och en att lyckas.`,
  },
  {
    name: "Fredrik Nygren, Hudiksvalls kommun",
    role: "Metodstödjare",
    image: "/Fredrik.jpg",
    email: "fredrik.nygren@hudiksvall.se",
    phone: "070-1904386",
    text: `Jag är utbildad hälsopedagog och har arbetat med människor i utsatta situationer i över ett decennium. Jag brinner särskilt för ungdomar och för att skapa förutsättningar för dem att känna tillhörighet, få tilltro till sin egen förmåga och hitta sin väg framåt.

Mitt arbete utgår från ett salutogent perspektiv, där människors styrkor, resurser och det som skapar hälsa och mening får vara grunden. Genom att lyssna, bygga förtroende och ta vara på personens egna intressen vill jag bidra till att nästa steg känns både möjligt och meningsfullt.`,
  },
  {
    name: "Jenny Nilsen, Hudiksvalls kommun",
    role: "Individstödjare",
    image: "/Jenny.jpg",
    email: "jenny.nilsen@hudiksvall.se",
    phone: "070-2453346",
    text: `Jag är en utbildad beteendevetare som hittar min största drivkraft i att tillsammans med målgruppen för projektet hitta kreativa och anpassade lösningar framåt. Som person är jag nyfiken, har nära till skratt och ser hellre förmågor än hinder.

Min bakgrund inom skola, HVB, kriminalvård och socialtjänst har gett mig en bred erfarenhet av att möta människor i olika livssituationer.

För mig är det ett stort förtroende att få finnas där för unga vuxna under en avgörande fas i livet, där rätt stöd och förutsättningar kan öppna nya dörrar mot studier och arbetsmarknad. Målet är att stärka de resurser som unga vuxna redan har. Jag tror på ett inkluderande samhälle där vi tillsammans behöver värna om framtida kompetens.`,
  },
  {
    name: "Lina Brolund, Hudiksvalls kommun",
    role: "Individstödjare",
    image: "/Lina.jpg",
    email: "lina.brolund@hudiksvall.se",
    phone: "072-2318779",
    text: `Jag är utbildad socionom och har under hela mitt yrkesliv arbetat med att stötta människor, bland annat inom omsorgen, socialpsykiatrin, skolan och socialtjänsten. Jag har valt att arbeta med ungdomar eftersom jag vill finnas där under en viktig period i livet, stärka deras möjligheter och bidra till att varje ung person blir sedd, lyssnad på och får rätt stöd för att nå sina mål. Mitt engagemang bygger på en stark övertygelse om vikten av social hållbarhet och jag tror att alla människor som vill kan bidra och vara en del av samhället, bara de får rätt förutsättningar.`,
  },
  {
    name: "My Wallström KAA, Ljusdals kommun",
    role: "Individstödjare",
    image: "/My.jpg",
    email: "my.wallstrom@ljusdal.se",
    phone: "0651- 182 36",
    text: `Jag är socionom sedan 2017 och har arbetat med ungdomar inom socialtjänsten och som skolkurator för årskurs F–9. Jag tycker om att möta unga med olika erfarenheter och få följa deras utveckling. Att kunna ge stöd som hjälper dem närmare sina drömmar och en sysselsättning på sina egna villkor är ett privilegium. Jag lär mig också mycket av ungdomarna själva. Jag brinner för att alla unga ska få förutsättningar att välja sin framtid.`,
  },
  {
    name: "Josefin Karlsson, Ljusdals kommun",
    role: "Individstödjare",
    image: "/Josefin.jpg",
    email: "Josefin.karlsson@ljusdal.se",
    phone: " 070-202 41 32",
    text: `Jag har jobbat med människor i många år. Men har med tiden hittat min plats i arbetet med ungdomar.

För mig handlar det om att lyssna, och finnas där även när livet känns rörigt.

Jag tror på att alla har sina egna styrkor och förmågor, även om man inte alltid ser dem själv.`,
  },
  {
    name: "Pär Karlsson, Nordanstigs kommun",
    role: "Individstödjare",
    image: "/Pär.jpg",
    email: "par.karlsson@nordanstig.se",
    phone: "072-534 17 00",
    text: `Jag har min bakgrund som lärare och för 13 år sedan lämnade jag skolans värld och började arbeta med ensamkommande barn. Sedan 2016 jobbar jag i Nordanstig med ungdomar på enheten Arbete och Försörjning.

Förutsättningarna ser olika ut för oss alla och vissa behöver mer hjälp och stöd för att ta sig framåt. Jag trivs med att vara den som ledsagar både ungdomar och föräldrar.

Jag tror på att använda sig av individens egen drivkraft för att nå framsteg.

Vi behöver alla en framtidstro och ett mål att jobba mot.`,
  },
];

const links = [
  {
    title: "Räkna med mig II",
    label: "Pågående projekt",
    text: "Information om den nuvarande insatsen, projektets inriktning och kommande material.",
    href:
      "https://finsamgavleborg.se/insatser/information-insats-rakna-med-mig-ii-hudiksvall-ljusdal-nordanstig-norra-halsingland/information-insats-rakna-med-mig-ii-hudiksvall-ljusdal-nordanstig-norra-halsingland.aspx",
    external: true,
  },
  {
    title: "Räkna med mig!",
    label: "Tidigare projekt",
    text: "Här finns material från det tidigare projektet, bland annat rapporter och ansökan.",
    href:
      "https://finsamgavleborg.se/insatser/information-insats-rakna-med-mig-hudiksvall.aspx#ancor-8638",
    external: true,
  },
  {
    title: "Publiceringar",
    label: "Läs mer",
    text: "Artiklar och berättelser om Räkna med mig och arbetet tillsammans med unga.",
    href: "#media",
    external: false,
  },
{
  title: "Räkna med mig",
  label: "Slutrapport hösten 2026",
  text: "Läs slutrapporten och ta del av projektets erfarenheter och resultat.",
  href: "/Slutrapport hösten 2026.pdf",
  external: true,
},
];

const media = [
  {
    title: "”Krav på individen löser inte utanförskapet”",
    source: "Socionomen",
    href: "https://socionomen.se/krav-pa-individen-loser-inte-utanforskapet/",
  },
  {
    title: "Ny satsning ska hjälpa unga vuxna ut i arbetslivet",
    source: "Hudiksvalls Tidning",
    href:
      "https://www.ht.se/hudiksvall/ny-satsning-ska-hjalpa-unga-vuxna-ut-i-arbetslivet/",
  },
  {
    title: "”För första gången kände jag mig förstådd”",
    source: "Hudiksvalls Tidning",
    href:
      "https://www.ht.se/hudiksvall/for-forsta-gangen-kande-jag-mig-forstadd/",
  },
{
  source: "MUCF · Webbsändning",
  title: "Räkna med mig – fler möjligheter för unga",
  href: "https://www.youtube.com/live/7M7m6MyMdJM",
},

];

function Eyebrow({ children }) {
  return (
    <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#3BAFA3] sm:text-xs sm:tracking-[0.18em]">
      {children}
    </p>
  );
}
function TeamCard({ person }) {
  const [showContact, setShowContact] = useState(false);

  return (
    <article className="group min-w-0">
      {/* BILD */}
      <div className="relative aspect-[4/5] overflow-hidden rounded-[20px] bg-[#E8F7F5] sm:rounded-[24px]">
        {person.image ? (
          <img
            src={person.image}
            alt={person.name}
            className="
              h-full
              w-full
              object-cover
              transition-transform
              duration-700
              group-hover:scale-[1.03]
            "
          />
        ) : (
          <div className="flex h-full items-center justify-center">
            <span className="text-5xl font-semibold tracking-[-0.08em] text-[#3BAFA3]/20">
              Rm
            </span>
          </div>
        )}
      </div>

      {/* INFO */}
      <div className="mt-4 min-w-0 sm:mt-5">
        {/* NAMN */}
        <h3
          className="
            text-base
            font-semibold
            leading-6
            tracking-[-0.025em]
            text-neutral-900
            sm:text-lg
          "
        >
          {person.name}
        </h3>

        {/* ROLL */}
        {person.role && (
          <p className="mt-1 text-sm leading-5 text-[#3BAFA3]">
            {person.role}
          </p>
        )}

        {/* KONTAKT */}
        {(person.phone || person.email) && (
          <div className="mt-4">
            <button
              type="button"
              onClick={() => setShowContact(!showContact)}
              aria-expanded={showContact}
              className="
                inline-flex
                items-center
                gap-2
                text-sm
                font-semibold
                text-neutral-900
                transition-colors
                hover:text-[#3BAFA3]
              "
            >
              <span>
                {showContact ? "Dölj kontaktuppgifter" : "Visa kontaktuppgifter"}
              </span>

              <FaArrowRight
                size={10}
                className={`
                  transition-transform
                  duration-300
                  ${showContact ? "rotate-90" : "group-hover:translate-x-1"}
                `}
              />
            </button>

            {showContact && (
              <div
                className="
                  mt-3
                  rounded-[18px]
                  border
                  border-neutral-200
                  bg-white
                  p-4
                  sm:rounded-[20px]
                  sm:p-5
                "
              >
                <p
                  className="
                    text-[10px]
                    font-semibold
                    uppercase
                    tracking-[0.16em]
                    text-[#3BAFA3]
                    sm:text-[11px]
                  "
                >
                  Kontakt
                </p>

                <div className="mt-3 space-y-1.5">
                  {person.phone && (
                    <a
                      href={`tel:${person.phone.replace(/\s/g, "")}`}
                      className="
                        block
                        text-sm
                        font-medium
                        leading-6
                        text-neutral-700
                        transition-colors
                        hover:text-[#3BAFA3]
                      "
                    >
                      {person.phone}
                    </a>
                  )}

                  {person.email && (
                    <a
                      href={`mailto:${person.email}`}
                      className="
                        block
                        break-words
                        text-sm
                        leading-6
                        text-neutral-700
                        transition-colors
                        hover:text-[#3BAFA3]
                      "
                    >
                      {person.email}
                    </a>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* STORY */}
        {person.text && (
          <div className="mt-5 border-t border-neutral-200 pt-4 sm:mt-6 sm:pt-5">
            <p
              className="
                whitespace-pre-line
                text-sm
                leading-7
                text-neutral-500
                sm:text-[15px]
              "
            >
              {person.text}
            </p>
          </div>
        )}
      </div>
    </article>
  );
}
function LinkCard({ item }) {
  return (
    <a
      href={item.href}
      target={item.external ? "_blank" : undefined}
      rel={item.external ? "noreferrer" : undefined}
      className="group block min-w-0 border-t border-neutral-200 pt-5 sm:pt-6"
    >
      <div className="flex items-start justify-between gap-4">
        <p className="min-w-0 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#3BAFA3] sm:text-xs sm:tracking-[0.16em]">
          {item.label}
        </p>

        {item.external ? (
          <FaExternalLinkAlt
            size={11}
            className="mt-1 shrink-0 text-neutral-300 transition-colors group-hover:text-[#3BAFA3]"
          />
        ) : (
          <FaArrowRight
            size={12}
            className="mt-1 shrink-0 text-[#3BAFA3] transition-transform duration-300 group-hover:translate-x-1.5"
          />
        )}
      </div>

      <h3 className="mt-4 text-xl font-semibold leading-7 tracking-[-0.03em] text-neutral-900 sm:mt-5">
        {item.title}
      </h3>

      <p className="mt-3 max-w-sm text-sm leading-7 text-neutral-500">
        {item.text}
      </p>
    </a>
  );
}

export default function MyndigheterPage() {
  const [openPrinciple, setOpenPrinciple] = useState(0);
  const [activeMethod, setActiveMethod] = useState(null);
  const [activePreview, setActivePreview] = useState(null);

  return (
    <main className="min-h-screen overflow-x-hidden bg-white text-neutral-900">
      {/* HEADER */}
      <header className="relative z-30 bg-white">
        <div className="mx-auto flex max-w-6xl min-w-0 items-center justify-between gap-3 px-4 py-3 sm:gap-5 sm:px-6 sm:py-4 md:px-10 md:py-5 lg:px-16">
         {/* LOGO */}
<Link
  to="/"
  className="group flex min-w-0 shrink items-center"
  aria-label="Räkna med mig – startsida"
>
  <img
    src="/icon.png"
    alt="Räkna med mig"
    className="
      h-[120px]
      md:h-[150px]
      w-auto
      max-w-full
      object-contain
      transition-transform
      duration-300
      group-hover:scale-[1.03]
    "
  />
</Link>
          <a
            href="#teamet"
            className="
              group
              inline-flex
              shrink-0
              items-center
              gap-1.5
              rounded-full
              bg-[#3BAFA3]
              px-3.5
              py-2
              text-xs
              font-semibold
              text-white
              shadow-[0_5px_18px_rgba(59,175,163,0.14)]
              transition-all
              duration-300
              hover:-translate-y-0.5
              hover:bg-[#31988e]
              hover:shadow-[0_10px_28px_rgba(59,175,163,0.20)]
              sm:gap-2
              sm:px-5
              sm:py-2.5
              sm:text-sm
              md:px-6
              md:py-3
            "
          >
            Kontakta oss

            <FaArrowRight
              size={10}
              className="transition-transform duration-300 group-hover:translate-x-1 sm:size-[12px]"
            />
          </a>
        </div>
      </header>

      {/* INTRO */}
      <section className="overflow-hidden bg-white">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="grid gap-10 sm:gap-12 xl:grid-cols-[0.9fr_1.1fr] xl:gap-24">
            <div>
              <Eyebrow>Om Räkna med mig</Eyebrow>

              <h1 className="mt-5 text-[40px] font-semibold leading-[0.97] tracking-[-0.055em] sm:text-5xl md:text-6xl lg:text-[68px] xl:text-[76px]">
                Ett annat sätt att
                <br />
                se på vägen framåt.
              </h1>
            </div>

            <div className="max-w-2xl xl:pt-10">
              <p className="text-lg leading-8 text-neutral-700 sm:text-xl sm:leading-9">
                Räkna med mig utgår från att unga människor har förmågor,
                idéer och erfarenheter som behöver få ta plats.
              </p>

              <p className="mt-5 text-base leading-7 text-neutral-500 sm:text-[17px] sm:leading-8">
                Vårt arbete handlar om att skapa förutsättningar för unga att
                använda och utveckla sina förmågor, vara delaktiga och hitta
                vägar mot arbete eller studier på sina egna villkor.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FILM */}
      <section className="bg-[#E8F7F5]">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="mb-8 grid gap-8 sm:mb-10 xl:grid-cols-[0.8fr_1.2fr] xl:items-end xl:gap-24">
            <div>
              <Eyebrow>Räkna med mig</Eyebrow>

              <h2 className="mt-4 text-[32px] font-semibold leading-[1.05] tracking-[-0.05em] sm:text-4xl md:text-5xl">
                Bron mellan människor och möjligheter.
              </h2>
            </div>

            <p className="max-w-xl text-base leading-7 text-neutral-600 sm:text-[17px] sm:leading-8">
              Se om Räkna med mig; och hur vi arbetar för att skapa vägar
              framåt tillsammans med unga och de verksamheter som finns runt
              dem.
            </p>
          </div>

          <div className="overflow-hidden rounded-[20px] bg-black shadow-[0_25px_70px_rgba(0,0,0,0.11)] sm:rounded-[28px]">
            <video
              controls
              playsInline
              preload="metadata"
              className="aspect-video w-full object-cover"
            >
              <source src="/RMM_Bron_movie.mp4" type="video/mp4" />
              Din webbläsare kan inte spela upp filmen.
            </video>
          </div>
        </div>
      </section>

      {/* NAME */}
      <section className="bg-white">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="grid gap-10 sm:gap-12 xl:grid-cols-[0.75fr_1.25fr] xl:gap-24">
            <div>
              <Eyebrow>Ett namn med två betydelser</Eyebrow>
            </div>

            <div className="max-w-3xl">
              <h2 className="text-[30px] font-semibold leading-[1.08] tracking-[-0.04em] sm:text-3xl md:text-4xl">
                ”Räkna med mig” kommer från de unga själva.
              </h2>

              <div className="mt-6 space-y-5 text-base leading-7 text-neutral-600 sm:mt-7 sm:text-[17px] sm:leading-8">
                <p>
                  Namnet kommer från de unga själva och vad de vill förmedla:
                  <span className="font-semibold text-neutral-900">
                    {" "}
                    räkna med mig.
                  </span>
                </p>

                <p>
                  De vi möter har förmågor, idéer och erfarenheter som behöver
                  få ta plats. Vårt ansvar är att skapa förutsättningar för
                  dem att använda och utveckla sina förmågor.
                </p>

                <p>
                  Vi behöver även de unga när vi planerar stödet, för de vill
                  också bli lyssnade på, vara delaktiga och veta att deras
                  tankar tas på allvar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRINCIPLES INTRO */}
      <section className="bg-neutral-950 text-white">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="grid gap-10 sm:gap-12 xl:grid-cols-[0.8fr_1.2fr] xl:gap-24">
            <div>
              <Eyebrow>Vårt arbetssätt</Eyebrow>

              <h2 className="mt-4 text-[34px] font-semibold leading-[1.05] tracking-[-0.05em] sm:text-4xl md:text-5xl">
                Våra
                <br />
                10 grundprinciper.
              </h2>
            </div>

            <div className="max-w-2xl">
              <p className="text-base leading-7 text-white/65 sm:text-lg sm:leading-8">
                Principerna hjälper oss att hålla fast vid det som är viktigt i
                mötet med unga och i samarbetet mellan verksamheter. De
                beskriver inte en färdig modell, utan ett förhållningssätt som
                vi fortsätter att utveckla.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PRINCIPLES */}
      <section className="bg-neutral-950 text-white">
        <div className="mx-auto max-w-6xl px-4 pb-14 sm:px-6 sm:pb-20 md:px-10 md:pb-24 lg:px-16 xl:pb-28">
          <div className="border-t border-white/15">
            {principles.map((item, index) => (
              <div key={item.number}>
                <button
                  type="button"
                  onClick={() =>
                    setOpenPrinciple(
                      openPrinciple === index ? -1 : index
                    )
                  }
                  className="group flex w-full min-w-0 items-center gap-3 border-b border-white/15 py-5 text-left sm:gap-5 sm:py-6"
                >
                  <span className="w-7 shrink-0 text-[11px] font-semibold tracking-[0.08em] text-[#3BAFA3] sm:w-9 sm:text-xs sm:tracking-[0.1em]">
                    {item.number}
                  </span>

                  <span className="min-w-0 flex-1 text-base font-semibold leading-6 tracking-[-0.025em] text-white sm:text-lg md:text-xl">
                    {item.title}
                  </span>

                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-white/15 text-[#3BAFA3] transition-colors group-hover:border-[#3BAFA3] sm:h-9 sm:w-9">
                    {openPrinciple === index ? (
                      <FaMinus size={9} />
                    ) : (
                      <FaPlus size={9} />
                    )}
                  </span>
                </button>

                {openPrinciple === index && (
                  <div className="grid grid-cols-[28px_1fr] border-b border-white/15 py-6 sm:grid-cols-[45px_1fr] sm:py-7">
                    <div />

                    <p className="max-w-3xl text-sm leading-7 text-white/60 sm:text-[16px] sm:leading-8">
                      {item.text}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROCESSMODELLEN */}
      <section className="bg-[#F8FAFA]">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="grid gap-10 sm:gap-12 xl:grid-cols-[0.7fr_1.3fr] xl:gap-24">
            {/* INTRO */}
            <div>
              <Eyebrow>Processmodellen</Eyebrow>

              <h2 className="mt-4 text-[34px] font-semibold leading-[1.05] tracking-[-0.05em] sm:text-4xl md:text-5xl">
                Från möte
                <br />
                till nästa steg.
              </h2>

              <p className="mt-5 max-w-md text-base leading-7 text-neutral-600 sm:mt-6 sm:text-[17px] sm:leading-8">
                Processmodellen visar hur vi arbetar tillsammans och tydliggör
                samverkan mellan aktörer genom hela processen – från
                identifiering till avslut.
              </p>

              <button
                type="button"
                onClick={() => setActiveMethod("processmodell")}
                className="
                  group
                  mt-7
                  inline-flex
                  w-full
                  items-center
                  justify-center
                  gap-3
                  rounded-full
                  bg-neutral-950
                  px-6
                  py-3
                  text-sm
                  font-semibold
                  text-white
                  transition-all
                  duration-300
                  hover:-translate-y-0.5
                  hover:bg-neutral-800
                  sm:w-auto
                "
              >
                Se processmodellen

                <FaArrowRight
                  size={11}
                  className="transition-transform duration-300 group-hover:translate-x-1.5"
                />
              </button>
            </div>

            {/* PROCESS IMAGE */}
            <div className="min-w-0">
              <button
                type="button"
                onClick={() => setActiveMethod("processmodell")}
                className="group block w-full overflow-hidden rounded-[20px] bg-white text-left shadow-[0_20px_60px_rgba(0,0,0,0.06)] ring-1 ring-neutral-200/70 sm:rounded-[28px]"
              >
                <div className="relative overflow-hidden p-4 sm:p-5 md:p-8">
                  <img
                    src="/Processmodellen.jpg"
                    alt="Processmodellen från möte till nästa steg"
                    className="w-full rounded-xl object-contain transition-transform duration-500 group-hover:scale-[1.02] sm:rounded-2xl"
                  />

                  <div className="pointer-events-none absolute inset-x-4 bottom-4 flex justify-end sm:inset-x-5 sm:bottom-5 md:inset-x-8 md:bottom-8">
                    <span className="max-w-[calc(100%-1rem)] rounded-full bg-neutral-950 px-3 py-2 text-[9px] font-semibold uppercase tracking-[0.1em] text-white shadow-lg sm:px-4 sm:text-[10px] sm:tracking-[0.14em]">
                      Öppna processmodellen
                    </span>
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* BOTTOM LINE */}
          <div className="mt-12 border-t border-neutral-200 pt-7 sm:mt-16 sm:pt-8">
            <div className="grid gap-6 sm:grid-cols-3 sm:gap-8">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#3BAFA3]">
                  01
                </p>
                <p className="mt-2 text-sm leading-7 text-neutral-600">
                  Innan aktivitetsersättning.
                </p>
              </div>

              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#3BAFA3]">
                  02
                </p>
                <p className="mt-2 text-sm leading-7 text-neutral-600">
                  Pågående aktivitetsersättning.
                </p>
              </div>

              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#3BAFA3]">
                  03
                </p>
                <p className="mt-2 text-sm leading-7 text-neutral-600">
                  Avslut aktivitetsersättning.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* METHOD TEASERS */}
      <section className="bg-white">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="mb-9 flex flex-col justify-between gap-6 sm:mb-12 xl:flex-row xl:items-end">
            <div>
              <Eyebrow>Metodbeskrivningen</Eyebrow>

              <h2 className="mt-4 max-w-3xl text-[34px] font-semibold leading-[1.05] tracking-[-0.05em] sm:text-4xl md:text-5xl">
                Nyfiken på hur Räkna med mig arbetar?
              </h2>
            </div>

            <p className="max-w-md text-sm leading-7 text-neutral-500">
              I vår metodhandbok har vi samlat våra erfarenheter, principer och
              sätt att omsätta dem i praktiken. Här får du några små smakprov
              från det som finns bakom kulisserna.
            </p>
          </div>

          {/* SNEAK PEEK – METODHANDBOK */}
          <button
            type="button"
            onClick={() => setActivePreview("metodhandbok")}
            className="group mb-6 block w-full overflow-hidden rounded-[20px] bg-[#F8FAFA] text-left transition-transform duration-300 hover:-translate-y-1 sm:mb-7 sm:rounded-[28px]"
          >
            <div className="grid items-center md:grid-cols-2">
              <div className="p-6 sm:p-8 md:p-10 lg:p-16">
                <span className="text-[11px] font-semibold tracking-[0.1em] text-[#3BAFA3] sm:text-xs sm:tracking-[0.12em]">
                  ETT LITET URDRAG
                </span>

                <h3 className="mt-4 max-w-lg text-[28px] font-semibold leading-tight tracking-[-0.04em] text-neutral-900 sm:mt-5 sm:text-3xl md:text-4xl">
                  Det finns mer bakom vårt arbetssätt.
                </h3>

                <p className="mt-4 max-w-lg text-sm leading-7 text-neutral-600 sm:mt-5">
                  I metodhandboken går vi närmare in på hur vi tänker, arbetar
                  och utvecklar stödet tillsammans med den unga. Här är bara en
                  liten glimt av innehållet.
                </p>

                <span className="mt-7 flex items-center gap-3 text-sm font-semibold text-[#3BAFA3] sm:mt-8">
                  Öppna sneak peek

                  <FaArrowRight
                    size={11}
                    className="transition-transform duration-300 group-hover:translate-x-1.5"
                  />
                </span>
              </div>

              <div className="relative flex min-h-[280px] items-center justify-center overflow-hidden bg-[#E8F7F5] p-6 sm:min-h-[320px] sm:p-8 md:min-h-[430px]">
                <div className="absolute inset-0 bg-gradient-to-br from-[#E8F7F5] via-[#E8F7F5] to-white/60" />

                <img
                  src="/metodhandbok.png"
                  alt="Sneak peek från Räkna med mig metodhandbok"
                  className="relative z-10 max-h-[280px] w-auto max-w-[90%] rounded-lg object-contain shadow-2xl transition-transform duration-500 group-hover:scale-[1.03] sm:max-h-[360px]"
                />

                <span className="absolute bottom-4 right-4 z-20 rounded-full bg-white/90 px-3 py-2 text-[9px] font-semibold uppercase tracking-[0.1em] text-neutral-500 shadow-sm sm:bottom-5 sm:right-5 sm:px-4 sm:text-[10px] sm:tracking-[0.12em]">
                  Metodhandbok
                </span>
              </div>
            </div>
          </button>

          {/* THREE METHOD TEASERS */}
          <div className="grid gap-5 sm:gap-7 md:grid-cols-2">
            {/* 01 */}
            <button
              type="button"
              onClick={() => setActiveMethod("principer")}
              className="
                group
                rounded-[20px]
                bg-[#E8F7F5]
                p-6
                text-left
                transition-transform
                duration-300
                hover:-translate-y-1
                sm:rounded-[24px]
                sm:p-8
              "
            >
              <span className="text-xs font-semibold tracking-[0.12em] text-[#3BAFA3]">
                01
              </span>

              <h3 className="mt-10 text-xl font-semibold tracking-[-0.03em] text-neutral-900 sm:mt-12">
                Så arbetar vi
              </h3>

              <p className="mt-4 text-sm leading-7 text-neutral-600">
                Tre metoder som ger individnära stöd och hjälper oss att
                utveckla verksamheten.
              </p>

              <span className="mt-7 flex items-center gap-3 text-sm font-semibold text-[#3BAFA3] sm:mt-8">
                Läs om våra metoder

                <FaArrowRight
                  size={11}
                  className="transition-transform duration-300 group-hover:translate-x-1.5"
                />
              </span>
            </button>

            {/* 02 */}
            <button
              type="button"
              onClick={() => setActiveMethod("samverkan")}
              className="
                group
                rounded-[20px]
                bg-neutral-950
                p-6
                text-left
                text-white
                transition-transform
                duration-300
                hover:-translate-y-1
                sm:rounded-[24px]
                sm:p-8
              "
            >
              <span className="text-xs font-semibold tracking-[0.12em] text-[#3BAFA3]">
                02
              </span>

              <h3 className="mt-10 text-xl font-semibold tracking-[-0.03em] sm:mt-12">
                Samverkan som arbetssätt
              </h3>

              <p className="mt-4 text-sm leading-7 text-white/55">
                Så bygger vi tillit, förståelse och en mer sammanhållen väg för
                den unga.
              </p>

              <span className="mt-7 flex items-center gap-3 text-sm font-semibold text-[#3BAFA3] sm:mt-8">
                Läs mer

                <FaArrowRight
                  size={11}
                  className="transition-transform duration-300 group-hover:translate-x-1.5"
                />
              </span>
            </button>
          </div>

          {/* SNEAK PEEK – LÄKARINTYG */}
          <button
            type="button"
            onClick={() => setActivePreview("läkarintyg")}
            className="group mt-6 block w-full overflow-hidden rounded-[20px] bg-neutral-950 text-left text-white transition-transform duration-300 hover:-translate-y-1 sm:mt-7 sm:rounded-[28px]"
          >
            <div className="grid items-center md:grid-cols-2">
              <div className="relative order-2 flex min-h-[280px] items-center justify-center overflow-hidden bg-neutral-900 p-6 sm:min-h-[320px] sm:p-8 md:order-1 md:min-h-[430px]">
                <div className="absolute inset-0 bg-gradient-to-br from-neutral-900 via-neutral-950 to-black" />

                <img
                  src="/läkarintyg.png"
                  alt="Sneak peek från läkarintyg"
                  className="relative z-10 max-h-[280px] w-auto max-w-[90%] rounded-lg object-contain shadow-2xl transition-transform duration-500 group-hover:scale-[1.03] sm:max-h-[360px]"
                />

                <span className="absolute bottom-4 left-4 z-20 rounded-full bg-white/10 px-3 py-2 text-[9px] font-semibold uppercase tracking-[0.1em] text-white/60 backdrop-blur-sm sm:bottom-5 sm:left-5 sm:px-4 sm:text-[10px] sm:tracking-[0.12em]">
                  Läkarintyg
                </span>
              </div>

              <div className="order-1 p-6 sm:p-8 md:order-2 md:p-10 lg:p-16">
                <span className="text-[11px] font-semibold tracking-[0.1em] text-[#3BAFA3] sm:text-xs sm:tracking-[0.12em]">
                  EN ANNAN DEL AV HELHETEN
                </span>

                <h3 className="mt-4 max-w-lg text-[28px] font-semibold leading-tight tracking-[-0.04em] sm:mt-5 sm:text-3xl md:text-4xl">
                  När fler delar behöver hänga ihop.
                </h3>

                <p className="mt-4 max-w-lg text-sm leading-7 text-white/60 sm:mt-5">
                  Förberedelsen inför läkarbesöket är en del av helheten. Här
                  får du en liten förhandsblick på hur vi stöttar individen
                  inför mötet och hjälper till att göra vardagens svårigheter
                  tydligare.
                </p>

                <span className="mt-7 flex items-center gap-3 text-sm font-semibold text-[#3BAFA3] sm:mt-8">
                  Öppna sneak peek

                  <FaArrowRight
                    size={11}
                    className="transition-transform duration-300 group-hover:translate-x-1.5"
                  />
                </span>
              </div>
            </div>
          </button>
        </div>
      </section>

      {/* METHOD MODALS */}
      {activeMethod === "principer" && (
        <PrinciperModal onClose={() => setActiveMethod(null)} />
      )}

      {activeMethod === "processmodell" && (
        <ProcessmodellModal onClose={() => setActiveMethod(null)} />
      )}

      {activeMethod === "samverkan" && (
        <SamverkanModal onClose={() => setActiveMethod(null)} />
      )}

      {/* SNEAK PEEK MODAL – METODHANDBOK */}
      {activePreview === "metodhandbok" && (
        <div
          className="fixed inset-0 z-[100] flex min-h-[100svh] items-center justify-center overflow-y-auto bg-black/60 p-3 backdrop-blur-sm sm:p-4"
          onClick={() => setActivePreview(null)}
        >
          <div
            className="relative my-2 w-full max-w-6xl overflow-hidden rounded-[22px] bg-white shadow-2xl sm:my-4 sm:max-h-[92svh] sm:rounded-[2rem]"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Metodhandboken"
          >
            {/* Close */}
            <button
              type="button"
              onClick={() => setActivePreview(null)}
              className="absolute right-3 top-3 z-30 flex h-10 w-10 items-center justify-center rounded-full bg-black text-white shadow-lg transition hover:scale-105 sm:right-5 sm:top-5 sm:h-11 sm:w-11"
              aria-label="Stäng"
            >
              <FaPlus className="rotate-45" size={14} />
            </button>

            <div className="grid max-h-[92svh] overflow-y-auto md:grid-cols-[0.8fr_1.2fr]">
              {/* IMAGE */}
              <div className="relative min-h-[300px] sm:min-h-[360px] md:min-h-full">
                <img
                  src="/metodhandbok.png"
                  alt="Metodhandboken"
                  className="absolute inset-0 h-full w-full object-cover"
                />

                <div className="absolute inset-0 bg-black/20" />

                <div className="absolute bottom-0 left-0 right-0 p-6 text-white sm:p-8">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.16em] sm:text-sm sm:tracking-[0.18em]">
                    Sneak peek
                  </p>

                  <h2 className="text-2xl font-semibold sm:text-3xl md:text-4xl">
                    Metodhandboken
                  </h2>

                  <p className="mt-2 text-sm leading-6 text-white/90 sm:mt-3">
                    En inblick i våra arbetssätt, erfarenheter och principer.
                  </p>
                </div>
              </div>

              {/* CONTENT */}
              <div className="p-5 sm:p-8 md:p-12">
                <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-black/50 sm:text-sm sm:tracking-[0.18em]">
                  Teaser ur metodbeskrivningen
                </p>

                <h2 className="mb-8 text-2xl font-semibold leading-tight text-[#222] sm:mb-10 sm:text-3xl md:text-4xl">
                  Så arbetar vi i Räkna med mig
                </h2>

                {/* SAMVERKAN */}
                <section className="mb-10 sm:mb-12">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Samverkan
                  </p>

                  <h3 className="mb-4 text-xl font-semibold leading-tight text-[#222] sm:mb-5 sm:text-2xl">
                    Hur samverkan etableras och utvecklas över tid
                  </h3>

                  <h4 className="mb-2 text-base font-semibold text-[#222] sm:text-lg">
                    Varför är detta viktigt?
                  </h4>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Målgruppen har ofta kontakt med flera olika verksamheter
                    samtidigt. För att stödet ska bli sammanhållet behöver de
                    aktörer som möter individen ha en gemensam förståelse för
                    uppdraget och ett fungerande samarbete.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Hållbar samverkan handlar inte om att sudda ut
                    organisationernas olika uppdrag. Tvärtom bygger den på att
                    varje aktör tar ansvar för sitt uppdrag samtidigt som man
                    ser hur de olika delarna tillsammans kan skapa ett bättre
                    stöd för individen.
                  </p>

                  <div className="mt-6 rounded-[18px] bg-[#f5f3ef] p-4 sm:p-5">
                    <p className="mb-2 font-semibold text-[#222]">Reflektion</p>

                    <p className="text-sm leading-7 text-[#555]">
                      Hållbar samverkan skapas inte genom ett undertecknat
                      avtal. Den växer fram när människor lär känna varandras
                      uppdrag, bygger förtroende och tillsammans tar ansvar för
                      den gemensamma målgruppen.
                    </p>
                  </div>
                </section>

                {/* LÄKARUTLÅTANDET */}
                <section className="mb-10 border-t border-black/10 pt-8 sm:mb-12 sm:pt-10">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Praktiskt stöd
                  </p>

                  <h3 className="mb-4 text-xl font-semibold leading-tight text-[#222] sm:mb-5 sm:text-2xl">
                    Läkarutlåtandet – stöd inför läkarbesöket
                  </h3>

                  <h4 className="mb-2 text-base font-semibold text-[#222] sm:text-lg">
                    Varför erbjuder vi stöd?
                  </h4>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    För många deltagare är läkarbesöket en av de utmanande
                    delarna i processen mot aktivitetsersättning. Många har
                    svårt att beskriva hur funktionsnedsättningen påverkar
                    vardagen eller att sätta ord på sådant som blivit en
                    naturlig del av livet.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Vårt stöd handlar därför inte om att påverka innehållet i
                    läkarens bedömning, utan om att hjälpa individen att vara
                    så väl förberedd som möjligt inför mötet.
                  </p>

                  <div className="mt-6 rounded-[18px] bg-[#f5f3ef] p-4 sm:p-5">
                    <p className="mb-2 font-semibold text-[#222]">Reflektion</p>

                    <p className="text-sm leading-7 text-[#555]">
                      Ett bra läkarbesök handlar inte om att övertyga läkaren.
                      Det handlar om att ge individen möjlighet att beskriva
                      sin vardag så att läkaren får ett så bra underlag som
                      möjligt för sin bedömning.
                    </p>
                  </div>
                </section>

                {/* PRINCIP 10 */}
                <section className="border-t border-black/10 pt-8 sm:pt-10">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Princip 10
                  </p>

                  <h3 className="mb-4 text-xl font-semibold leading-tight text-[#222] sm:mb-5 sm:text-2xl">
                    Vi tar ansvar för vår arbetsmiljö och vårt engagemang
                  </h3>

                  <h4 className="mb-2 text-base font-semibold text-[#222] sm:text-lg">
                    Vad menar vi?
                  </h4>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    I Räkna med mig är vi som möter deltagarna verksamhetens
                    viktigaste verktyg. Våra förhållningssätt, vår energi och
                    vår förmåga att skapa tillit påverkar kvaliteten i det stöd
                    vi ger.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Att arbeta nära människor kräver både närvaro och
                    känslomässig energi. Därför skapar vi utrymme för stöd,
                    återhämtning, reflektion och gemensamt lärande.
                  </p>

                  <div className="mt-6">
                    <p className="mb-3 font-semibold text-[#222]">
                      Det här vilar principen på
                    </p>

                    <p className="text-sm leading-7 text-[#555]">
                      Den här principen utgår från reflexiv praktik, vilket
                      innebär att vi kontinuerligt granskar och utvecklar vårt
                      eget förhållningssätt och vår yrkesutövning.
                    </p>
                  </div>

                  <div className="mt-7 border-t border-black/10 pt-5 sm:mt-8 sm:pt-6">
                    <p className="text-base font-semibold leading-7 text-[#222] sm:text-lg">
                      Vi hjälper varandra att bevara nyfikenheten, hoppet och
                      tron på att utveckling är möjlig.
                    </p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SNEAK PEEK MODAL – LÄKARINTYG */}
      {activePreview === "läkarintyg" && (
        <div
          className="fixed inset-0 z-[100] flex min-h-[100svh] items-center justify-center overflow-y-auto bg-black/60 p-3 backdrop-blur-sm sm:p-4"
          onClick={() => setActivePreview(null)}
        >
          <div
            className="relative my-2 w-full max-w-6xl overflow-hidden rounded-[22px] bg-white shadow-2xl sm:my-4 sm:max-h-[92svh] sm:rounded-[2rem]"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Läkarutlåtandet"
          >
            {/* Close */}
            <button
              type="button"
              onClick={() => setActivePreview(null)}
              className="absolute right-3 top-3 z-30 flex h-10 w-10 items-center justify-center rounded-full bg-black text-white shadow-lg transition hover:scale-105 sm:right-5 sm:top-5 sm:h-11 sm:w-11"
              aria-label="Stäng"
            >
              <FaPlus className="rotate-45" size={14} />
            </button>

            <div className="grid max-h-[92svh] overflow-y-auto md:grid-cols-[0.8fr_1.2fr]">
              {/* IMAGE */}
              <div className="relative min-h-[300px] sm:min-h-[360px] md:min-h-full">
                <img
                  src="/metodhandbok.png"
                  alt="Läkarutlåtandet"
                  className="absolute inset-0 h-full w-full object-cover"
                />

                <div className="absolute inset-0 bg-black/20" />

                <div className="absolute bottom-0 left-0 right-0 p-6 text-white sm:p-8">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.16em] sm:text-sm sm:tracking-[0.18em]">
                    Sneak peek
                  </p>

                  <h2 className="text-2xl font-semibold sm:text-3xl md:text-4xl">
                    Läkarutlåtandet
                  </h2>

                  <p className="mt-2 text-sm leading-6 text-white/90 sm:mt-3">
                    Stöd inför läkarbesöket och förberedelse inför
                    läkarutlåtandet.
                  </p>
                </div>
              </div>

              {/* CONTENT */}
              <div className="p-5 sm:p-8 md:p-12">
                <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-black/50 sm:text-sm sm:tracking-[0.18em]">
                  Teaser ur metodbeskrivningen
                </p>

                <h2 className="mb-8 text-2xl font-semibold leading-tight text-[#222] sm:mb-10 sm:text-3xl md:text-4xl">
                  Läkarutlåtandet – stöd inför läkarbesöket
                </h2>

                {/* VARFÖR */}
                <section className="mb-10 sm:mb-12">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Varför erbjuder vi stöd?
                  </p>

                  <h3 className="mb-4 text-xl font-semibold leading-tight text-[#222] sm:mb-5 sm:text-2xl">
                    Att vara förberedd inför mötet
                  </h3>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    För många deltagare är läkarbesöket en av de utmanande
                    delarna i processen mot aktivitetsersättning. Många har
                    svårt att beskriva hur funktionsnedsättningen påverkar
                    vardagen eller att sätta ord på sådant som blivit en
                    naturlig del av livet.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Vi har också sett att många deltagare vill visa sina starka
                    sidor när de träffar vården. De vill klara sig själva,
                    framstå som självständiga eller undvika att belasta andra.
                    Det kan göra att viktiga delar av funktionsnedsättningen
                    aldrig kommer fram under besöket.
                  </p>

                  <p className="text-sm leading-7 text-[#555]">
                    Vårt stöd handlar därför inte om att påverka innehållet i
                    läkarens bedömning, utan om att hjälpa individen att vara
                    så väl förberedd som möjligt inför mötet.
                  </p>
                </section>

                {/* PRAKTISKT STÖD */}
                <section className="mb-10 border-t border-black/10 pt-8 sm:mb-12 sm:pt-10">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Praktiskt stöd
                  </p>

                  <h3 className="mb-4 text-xl font-semibold leading-tight text-[#222] sm:mb-5 sm:text-2xl">
                    Förberedelse inför läkarbesök och läkarutlåtande
                  </h3>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Till detta arbetssätt finns en särskild lathund med stöd
                    inför läkarbesöket. Lathunden innehåller exempel på hur
                    individen kan förbereda sig, vilka områden som är viktiga
                    att reflektera över och hur vardagens konsekvenser kan
                    konkretiseras inför mötet.
                  </p>

                  <button
                    type="button"
                    onClick={() => setActivePreview("läkarbilaga")}
                    className="group mt-5 w-full rounded-[18px] bg-[#f5f3ef] p-4 text-left transition hover:-translate-y-0.5 hover:bg-[#eeeae4] sm:mt-6 sm:p-5"
                  >
                    <p className="font-semibold text-[#222]">Se bilaga</p>

                    <p className="mt-1 text-sm leading-6 text-[#555]">
                      Förberedelse inför läkarbesök och läkarutlåtande
                    </p>

                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#3BAFA3]">
                      Öppna bilagan
                      <FaArrowRight
                        size={11}
                        className="transition-transform duration-300 group-hover:translate-x-1"
                      />
                    </span>
                  </button>
                </section>

                {/* HUR ARBETAR VI */}
                <section className="mb-10 border-t border-black/10 pt-8 sm:mb-12 sm:pt-10">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Hur arbetar vi?
                  </p>

                  <h3 className="mb-4 text-xl font-semibold leading-tight text-[#222] sm:mb-5 sm:text-2xl">
                    Från förberedelse till ett tryggare möte
                  </h3>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Vi lägger stor vikt vid att förbereda individen inför
                    läkarbesöket. Tillsammans går vi igenom syftet med besöket,
                    vad läkaren behöver ta ställning till och varför det är
                    viktigt att beskriva hur funktionsnedsättningen faktiskt
                    påverkar vardagen.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Vi hjälper individen att reflektera över sin vardag och
                    hitta konkreta exempel på situationer där
                    funktionsnedsättningen innebär svårigheter. Fokus ligger
                    inte på diagnosen i sig, utan på vilka konsekvenser den får
                    i det dagliga livet. Det kan handla om studier, arbete,
                    struktur, sociala situationer, återhämtning, stress eller
                    andra områden som påverkar funktionsförmågan.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Om individen önskar följer vi också med som stöd under
                    läkarbesöket. Vår roll är då att skapa trygghet och, när
                    individen vill det, hjälpa till att förtydliga eller
                    komplettera sådant som riskerar att inte komma fram. Det är
                    alltid individens berättelse som står i centrum. Alternativt
                    så förbereder vi den person som istället ska följa med.
                  </p>

                  <p className="text-sm leading-7 text-[#555]">
                    Vi har också lärt oss att ett bra läkarbesök sällan handlar
                    om att säga mer – utan om att säga rätt saker. Konkreta
                    exempel från vardagen ger ofta en tydligare bild än
                    allmänna beskrivningar av hur individen mår.
                  </p>
                </section>

                {/* VAD HAR VI LÄRT OSS */}
                <section className="mb-10 border-t border-black/10 pt-8 sm:mb-12 sm:pt-10">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Vad har vi lärt oss?
                  </p>

                  <h3 className="mb-4 text-xl font-semibold leading-tight text-[#222] sm:mb-5 sm:text-2xl">
                    Konkretisering gör skillnad
                  </h3>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Vi har lärt oss att många deltagare har svårt att beskriva
                    sina svårigheter. De har ofta levt länge med sin
                    funktionsnedsättning och ser den som en naturlig del av
                    vardagen. Det gör att sådant som innebär stora
                    begränsningar för individen inte alltid uppfattas som
                    viktigt att berätta.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    Vi har också sett att konkreta exempel är betydligt mer
                    hjälpsamma än generella beskrivningar. När individen kan
                    beskriva hur en vanlig dag ser ut eller ge exempel på
                    situationer som inte fungerar blir det lättare för vården
                    att förstå hur funktionsnedsättningen påverkar
                    funktionsförmågan.
                  </p>

                  <p className="mb-4 text-sm leading-7 text-[#555]">
                    En annan viktig erfarenhet är att många deltagare känner
                    stor oro inför läkarbesöket. Bara att veta hur besöket går
                    till och vad syftet är kan minska stressen och göra det
                    lättare att berätta om sin situation.
                  </p>

                  <p className="text-sm leading-7 text-[#555]">
                    Det är viktigt att komma ihåg att vår roll är att ge
                    individen bästa möjliga förutsättningar att beskriva sin
                    situation på ett tydligt och sanningsenligt sätt. Den
                    medicinska bedömningen och innehållet i läkarutlåtandet är
                    alltid läkarens ansvar.
                  </p>
                </section>

                {/* REFLEKTION */}
                <section className="border-t border-black/10 pt-8 sm:pt-10">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.1em] text-black/45 sm:text-sm sm:tracking-[0.12em]">
                    Reflektion
                  </p>

                  <div className="mt-5 rounded-[18px] bg-[#f5f3ef] p-4 sm:mt-6 sm:p-5">
                    <p className="text-base font-semibold leading-7 text-[#222] sm:text-lg sm:leading-relaxed">
                      Ett bra läkarbesök handlar inte om att övertyga läkaren.
                      Det handlar om att ge individen möjlighet att beskriva
                      sin vardag så att läkaren får ett så bra underlag som
                      möjligt för sin bedömning.
                    </p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* BILAGA – LÄKARINTYG */}
      {activePreview === "läkarbilaga" && (
        <div
          className="fixed inset-0 z-[200] flex min-h-[100svh] items-center justify-center overflow-y-auto bg-black/80 p-3 backdrop-blur-sm sm:p-4"
          onClick={() => setActivePreview(null)}
        >
          <div
            className="relative flex max-h-[95svh] max-w-6xl items-center justify-center"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Förberedelse inför läkarbesök och läkarutlåtande"
          >
            <button
              type="button"
              onClick={() => setActivePreview(null)}
              className="absolute right-2 top-2 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-black text-white shadow-lg transition hover:scale-105 sm:right-3 sm:top-3 sm:h-11 sm:w-11"
              aria-label="Stäng"
            >
              <span className="text-xl leading-none">×</span>
            </button>

            <img
              src="/läkarintyg.png"
              alt="Förberedelse inför läkarbesök och läkarutlåtande"
              className="max-h-[88svh] w-auto max-w-full rounded-xl object-contain shadow-2xl sm:max-h-[90vh] sm:rounded-2xl"
            />
          </div>
        </div>
      )}

      {/* TEAM */}
      <section id="teamet" className="scroll-mt-6 bg-[#F8FAFA]">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="mb-9 grid gap-7 sm:mb-12 sm:gap-8 xl:grid-cols-[0.8fr_1.2fr] xl:gap-24">
            <div>
              <Eyebrow>Vi som arbetar i projekten</Eyebrow>

              <h2 className="mt-4 text-[34px] font-semibold leading-[1.05] tracking-[-0.05em] sm:text-4xl md:text-5xl">
                Människorna
                <br />
                bakom arbetet.
              </h2>
            </div>

            <p className="max-w-xl text-base leading-7 text-neutral-500 sm:text-[17px] sm:leading-8">
              Räkna med mig drivs av människor med olika erfarenheter,
              kompetenser och perspektiv. Tillsammans utvecklar vi arbetet och
              lär oss av de unga och av varandra.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-14 xl:grid-cols-3">
            {teamet.map((person) => (
              <TeamCard key={person.name} person={person} />
            ))}
          </div>
        </div>
      </section>

      {/* PROJECT LINKS */}
      <section className="bg-white">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="mb-9 sm:mb-12">
            <Eyebrow>Projektet</Eyebrow>

            <h2 className="mt-4 max-w-3xl text-[34px] font-semibold leading-[1.05] tracking-[-0.05em] sm:text-4xl md:text-5xl">
              Läs vidare om Räkna med mig.
            </h2>
          </div>

          <div className="grid gap-x-8 gap-y-10 sm:gap-x-10 md:grid-cols-2 xl:grid-cols-3">
            {links.map((item) => (
              <LinkCard key={item.title} item={item} />
            ))}
          </div>
        </div>
      </section>

     {/* MEDIA */}
<section id="media" className="scroll-mt-6 bg-[#E8F7F5]">
  <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">

    {/* Rubrik */}
    <div className="mb-9 sm:mb-12">
      <Eyebrow>Publiceringar</Eyebrow>

      <h2 className="mt-4 max-w-3xl text-[34px] font-semibold leading-[1.05] tracking-[-0.05em] sm:text-4xl md:text-5xl">
        Röster och berättelser om arbetet.
      </h2>
    </div>

    {/* Publiceringar */}
    <div className="grid gap-x-8 gap-y-10 sm:gap-x-10 md:grid-cols-2 xl:grid-cols-3">
      {media.map((item) => {
        const isWebbsändning = item.source.includes("Webbsändning");
        const isPDF = item.source.includes("PDF");

        const linkText = isWebbsändning
          ? "Se webbsändningen"
          : isPDF
            ? "Läs dokumentet"
            : "Läs artikeln";

        return (
          <a
            key={item.title}
            href={item.href}
            target="_blank"
            rel="noreferrer"
            className="group block min-w-0 border-t border-neutral-300 pt-5 sm:pt-6"
          >
            <div className="flex items-start justify-between gap-4">
              <span className="min-w-0 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#3BAFA3] sm:text-xs sm:tracking-[0.16em]">
                {item.source}
              </span>

              <FaExternalLinkAlt
                size={11}
                className="mt-1 shrink-0 text-neutral-400 transition-colors group-hover:text-[#3BAFA3]"
              />
            </div>

            <h3 className="mt-4 text-xl font-semibold leading-7 tracking-[-0.03em] text-neutral-900 sm:mt-5">
              {item.title}
            </h3>

            <div className="mt-5 flex items-center gap-3 text-sm font-semibold text-[#3BAFA3] sm:mt-6">
              {linkText}

              <FaArrowRight
                size={11}
                className="transition-transform duration-300 group-hover:translate-x-1.5"
              />
            </div>
          </a>
        );
      })}
    </div>

  </div>
</section>
      {/* CONTACT */}
      <section id="kontakt" className="scroll-mt-6 bg-neutral-950 text-white">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:px-10 md:py-24 lg:px-16 xl:py-28">
          <div className="grid gap-10 sm:gap-12 xl:grid-cols-[1fr_0.7fr] xl:items-end xl:gap-24">
            <div>
              <Eyebrow>Om Räkna med mig</Eyebrow>

              <h2 className="mt-5 max-w-3xl text-[40px] font-semibold leading-[0.98] tracking-[-0.055em] sm:text-5xl md:text-6xl">
                Vill du veta mer om hur vi arbetar?
              </h2>

              <p className="mt-5 max-w-2xl text-base leading-7 text-white/60 sm:mt-6 sm:text-lg sm:leading-8">
                I metodbeskrivningen har vi samlat det vi har lärt oss under
                arbetet med Räkna med mig. Den beskriver både våra
                grundprinciper och hur vi omsätter dem i praktiken – från det
                första mötet med en ung person till samverkan och planering av
                nästa steg.
              </p>

              <p className="mt-4 max-w-2xl text-base leading-7 text-white/60 sm:mt-5 sm:text-lg sm:leading-8">
                Här på sidan delar vi några smakprov ur beskrivningen. Vill du
                veta mer om arbetssättet är du välkommen att kontakta oss.
              </p>
            </div>

             {/* =====================================================
        KONTAKTPERSON
    ===================================================== */}

    <div
      className="
        group
        min-w-0
        overflow-hidden
        rounded-[18px]
        bg-white
        shadow-[0_14px_40px_rgba(0,0,0,0.055)]
        ring-1
        ring-black/[0.04]

        sm:rounded-[22px]
      "
    >
      <div
        className="
          grid
          grid-cols-[0.9fr_1.1fr]
        "
      >

        {/* =================================================
            BILD
        ================================================= */}

        <div
          className="
            relative
            h-[115px]
            overflow-hidden
            bg-[#EAF5F3]

            sm:h-[170px]

            md:h-[200px]
          "
        >
          <img
            src="/Sofia.jpg"
            alt="Sofia Groth"
            className="
              h-full
              w-full
              object-cover
              object-center

              transition-transform
              duration-700

              group-hover:scale-[1.02]
            "
          />

          {/* Mjuk fade längst ner */}

          <div
            className="
              pointer-events-none
              absolute
              inset-x-0
              bottom-0
              h-12
              bg-gradient-to-t
              from-black/20
              to-transparent
            "
          />

        
        </div>

        {/* =================================================
            KONTAKTINFORMATION
        ================================================= */}

        <div
          className="
            flex
            min-w-0
            flex-col
            justify-center
            p-3

            sm:p-5

            md:p-6
          "
        >
          <p
            className="
              text-[8px]
              font-semibold
              uppercase
              tracking-[0.16em]
              text-[#3BAFA3]

              sm:text-[11px]
            "
          >
            Kontaktperson
          </p>

          <h3
            className="
              mt-1
              text-base
              font-semibold
              tracking-[-0.03em]
              text-neutral-900

              sm:mt-2
              sm:text-2xl
            "
          >
            Sofia Groth
          </h3>

          <p
            className="
              mt-0.5
              text-[10px]
              text-neutral-500

              sm:text-sm
            "
          >
            Insatsledare
          </p>

          <div
            className="
              my-2.5
              h-px
              bg-neutral-100

              sm:my-5
            "
          />

          <div
            className="
              space-y-1
              text-[9px]
              leading-4
              text-neutral-600

              sm:space-y-1.5
              sm:text-sm
              sm:leading-6
            "
          >
            {kontakter.map(([, phone, email]) => (
              <div key={email}>

                <a
                  href={`mailto:${email}`}
                  className="
                    block
                    break-words
                    transition-colors
                    hover:text-[#3BAFA3]
                  "
                >
                  {email}
                </a>

                <a
                  href={`tel:${phone.replace(/\s/g, "")}`}
                  className="
                    block
                    transition-colors
                    hover:text-[#3BAFA3]
                  "
                >
                  {phone}
                </a>

              </div>
            ))}
          </div>
        </div>
 </div>
 </div>

      </div>
 </div>

         
       
      </section>

      {/* FOOTER */}
      <footer className="border-t border-white/10 bg-neutral-950 text-white">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-6 text-center text-xs text-white/35 sm:px-6 sm:py-7 sm:text-left sm:text-sm md:flex-row md:items-center md:justify-between md:px-10 lg:px-16">
          <p>© Räkna med mig</p>
          <p>Hudiksvall · Ljusdal · Nordanstig</p>
        </div>
      </footer>
    </main>
  );
}